import "../../Style.css";
import "../../Brand.css";
import React from "react";
import { Box, Stack, Typography, Card } from "@mui/material";

const ServiceItem = ({ title, duration, price, selected, onToggle }) => {
  return (
    <Card className="card">
      <Stack padding={2} paddingRight="70px">
        <label>
          <Typography component="h3" fontSize="2.2rem" fontWeight="700">
            {title}
          </Typography>
          <Typography fontSize="1.4rem">{duration}</Typography>
          <Typography
            component="h3"
            fontSize="1.6rem"
            fontWeight="700"
            className="mt-2"
          >
            from {price}
          </Typography>
          <Box className="select-service">
            <input type="checkbox" checked={selected} onChange={onToggle} />
          </Box>
        </label>
      </Stack>
    </Card>
  );
};
export default ServiceItem;
